import { IconProps } from '@models/icons';

function ArrowDownIcon({ size, color, ...rest }:IconProps) {
    return (
        <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path
                d="M9.40135 14.999C8.03322 13.7749 8.89911 11.5085 10.7349 11.5085L19.2655 11.5085C21.1013 11.5085 21.9672 13.7749 20.5991 14.999L16.3338 18.8153C15.5745 19.4947 14.4259 19.4947 13.6666 18.8153L9.40135 14.999Z"
                fill="#6E6864"/>
        </svg>);
}

export default ArrowDownIcon;
